// const BaseUrl = 'http://uobam.sobo.com.tw';
// const BaseUrl = 'http://192.168.0.120';
const BaseUrl = '/';

export default BaseUrl;